import { fork, all } from 'redux-saga/effects';
import alertsSagas from 'app/modules/alerts/sagas';
import casesSagas from 'app/modules/casesOld/sagas';
import commentsSagas from 'app/modules/comments/sagas';
import entitiesSagas from 'app/modules/entitiesOld/sagas';
import ruleSagas from 'app/modules/rules/sagas';
import sessionSagas from 'app/modules/session/sagas';
import settingsSagas from 'app/modules/goAMLSettings/sagas';
import uploadSagas from 'app/modules/uploads/sagas';
import teamSagas from 'app/modules/teamsOld/sagas';
import filingSagas from 'app/modules/fincenSarOld/sagas';
import eventSagas from 'app/shared/eventsOld/sagas';
import searchSagas from 'app/modules/search/sagas';
import workflowSagas from 'app/modules/workflowButtonConfig/sagas';
import dropdownSagas from 'app/shared/dropdown/sagas';
import blacklistSagas from 'app/modules/lists/sagas';
import customChecklistSagas from 'app/shared/customChecklist/sagas';
import detectionModelsSagas from 'app/modules/detectionModels/sagas';
import permissionsSagas from 'app/modules/permissions/sagas';
import tableConfigSagas from 'app/shared/CustomConfig/sagas';
import goAMLSagas from 'app/modules/goAML/sagas';

const sagaList = [
  ...alertsSagas,
  ...blacklistSagas,
  ...casesSagas,
  ...commentsSagas,
  ...customChecklistSagas,
  ...dropdownSagas,
  ...entitiesSagas,
  ...eventSagas,
  ...filingSagas,
  ...goAMLSagas,
  ...ruleSagas,
  ...searchSagas,
  ...settingsSagas,
  ...sessionSagas,
  ...uploadSagas,
  ...teamSagas,
  ...workflowSagas,
  ...detectionModelsSagas,
  ...permissionsSagas,
  ...tableConfigSagas,
];

export default function* rootSaga() {
  yield all(sagaList.map((saga) => fork(saga)));
}
